import "./index.css"
import Button from "../button";

function EmptyState({message,openSiteAdder,buttonText}) {
  return <>
  <div className="empty-message-holder">
  <img src="./images/empty-state.png" alt="empty state" className="empty-state"></img>
  <div className="empty-message small-text">{message}</div>
  <Button text={buttonText || "Add site"} smallBool={true} addedFunction={openSiteAdder}></Button>
  </div>
  </>
  }

export default EmptyState;